import CertificationCapture from './Capture/Capture.vue';
import Certifications from './Certifications.vue';
import CertificationsCreateEdit from './CertificationsCreateEdit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Reports from './Report/Reports.vue';
import SamplingReport from './SamplingReport/SamplingReport.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const CertificationsRoutes = {
  path: 'certifications',
  name: 'Certificaciones',
  component: MasterTab,
  props: { reference: 'certificationTabs' },
  children: [
    {
      path: 'admin',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Certificaciones',
          component: Certifications,
          meta: {
            prefix_permission: 'certifications_admin',
          },
        },
        {
          path: 'create',
          name: 'Certificaciones',
          component: CertificationsCreateEdit,
          meta: {
            prefix_permission: 'certifications_admin',
          },
        },
        {
          path: 'edit',
          name: 'Certificaciones',
          component: CertificationsCreateEdit,
          meta: {
            prefix_permission: 'certifications_admin',
          },
        },
      ],
    },
    {
      path: 'reports',
      name: 'Certificaciones',
      component: Reports,
      meta: {
        prefix_permission: 'certifications_reports',
      },
    },
    {
      path: 'captures',
      name: 'Certificaciones',
      component: CertificationCapture,
      meta: {
        prefix_permission: 'certifications_captures',
      },
    },
    {
      path: 'samplingreport',
      name: 'Certificaciones',
      component: SamplingReport,
      meta: {
        prefix_permission: 'certifications_samplingreport',
      },
    },
  ],
};

export default CertificationsRoutes;
